import { useCallback } from 'react';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';

export const useProductsPermanentDeleteConfirm = (count?: number) => {
    const { confirm, renderConfirmModal } = useConfirm();

    const confirmDelete = useCallback(
        () =>
            confirm({
                title:
                    count && count > 1
                        ? 'Товары будут удалены без возможности восстановления'
                        : 'Товар будет удален без возможности восстановления',
                bodyText:
                    count && count > 1
                        ? 'Для резервного сохранения каталога рекомендуем скачать EXCEL с товарами'
                        : undefined,
                imageSrc: alertSrc,
                applyText: 'Да, удалить',
                cancelText: 'Отменить',
            }),
        [confirm, count]
    );

    return { confirm: confirmDelete, ProductsPermanentDeleteModal: renderConfirmModal() };
};
